import { render, staticRenderFns } from "./PassWordModify.vue?vue&type=template&id=69770952&scoped=true"
import script from "./PassWordModify.vue?vue&type=script&lang=js"
export * from "./PassWordModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69770952",
  null
  
)

export default component.exports